export * from './map-option-zone-remover.component';